import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import {
  Box,
  Breadcrumbs,
  CardMedia,
  Divider,
  Drawer,
  FormControl,
  Hidden,
  InputLabel,
  Link,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  MenuItem,
  Paper,
  Select,
  Stack,
  Theme,
  Typography,
  useTheme,
} from '@mui/material';
import { Location } from 'history';
import { ReactElement, ReactNode, useEffect, useState } from 'react';
import { CommonLayout } from '../commonComponents';
import { Redirect, Route, Switch, useHistory, useRouteMatch, Router } from 'react-router-dom';
import { AnimatedBox, ReportLeftLayout, SectionLinkItem } from './index';
import ClientStatement from './client-statement';
import TransactionStatement from './transaction-statement';
import PortfolioSummary from './portfolio-summary';
import CGStatement from './cg-statement';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { CGStatIcon, PortfolioReportIcon, PortfolioXirrDisabledIcon, PortfolioXirrIcon, ReportsCGSDisabledIcon, ReportsClientStatementIcon, ReportsDetailedHoldingDisabledIcon, ReportsHoldingDisabledIcon, ReportsMFTxnIconDisabled, ReportsTxnHistoryDisabledIcon, ReportsTxnStatIcon, RMHoldingReportIcon, T1ReportDisabledIcon, T1ReportIcon } from '../../assets/SvgIcons';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { MFTransactionWiseHoldingReport } from '../dashboard/Reports_Dashboard/MF-Transactionwise-holding-report';
import { HoldingReport } from '../dashboard/Reports_Dashboard/holding-report';
import { DetailedHoldingReport } from '../dashboard/Reports_Dashboard/DetailedHoldingReport';
import { PortfolioXirrReport } from '../dashboard/Reports_Dashboard/portfolio-xirr-report';
import { T1Report } from '../dashboard/Reports_Dashboard/t-1-report';


export interface ReportsRoutesObj {
  title: string;
  routerLink: string;
  isDisabled: boolean;
  icon: ReactElement;
  activeIcon: ReactElement;
  renderComponent: ReactElement;
  isHidden?: boolean
}

export default function InvestorReportRoute({
  location,
}: {
  location: Location<{ investorId: string; investorName: string }>;
}): JSX.Element {
  const theme = useTheme();
  const history = useHistory();
  const pathName = history.location.pathname;
  const { investorId, investorName } = location?.state || { investorId: '', investorName: '' };
  const [transitionClassName, setTransitionClassName] = useState('');
  const [isSideSectionDisabled, setSideSectionDisabled] = useState<boolean>(false)
  const { path } = useRouteMatch();
  const [openDrawer, setOpenDrawer] = useState<boolean>(false);


  const handleSideSectionDisabled = (value: boolean) => {
    setSideSectionDisabled(value)
  }

  //Dont change the routerLink it will affect functionality
  const leftMenuItem: ReportsRoutesObj[] = [
    {
      title: 'Client Statement',
      routerLink: `client-statement`,
      isDisabled: true,
      icon: <ReportsMFTxnIconDisabled />,
      activeIcon: <ReportsClientStatementIcon />,
      renderComponent: <ClientStatement location={location} handleSideSectionDisabled={handleSideSectionDisabled} />,
      isHidden: true
    },
    {
      title: 'Holding Report',
      routerLink: `holding-report`,
      isDisabled: false,
      icon: <ReportsHoldingDisabledIcon />,
      activeIcon: <RMHoldingReportIcon />,
      renderComponent: <HoldingReport handleSideSectionDisabled={handleSideSectionDisabled} />,
      isHidden: false
    },
    {
      title: 'MF Transaction-wise Holding Report',
      routerLink: `mf-transaction-wise-holding-report`,
      isDisabled: false,
      icon: <ReportsMFTxnIconDisabled />,
      activeIcon: <ReportsClientStatementIcon />,
      renderComponent: <MFTransactionWiseHoldingReport handleSideSectionDisabled={handleSideSectionDisabled} />,
      isHidden: false
    },
    {
      title: 'Transaction Statement',
      routerLink: `transaction-statement`,
      isDisabled: false,
      icon: <ReportsTxnHistoryDisabledIcon />,
      activeIcon: <ReportsTxnStatIcon />,
      renderComponent: <TransactionStatement location={location} handleSideSectionDisabled={handleSideSectionDisabled} />,
      isHidden: false
    },
    // {
    //   title: 'Portfolio Summary',
    //   routerLink: `portfolio-summary`,
    //   isDisabled: false,
    //   icon: <PortfolioReportIcon />,
    //   activeIcon: <PortfolioReportIcon />
    // },
    {
      title: 'Capital Gain Statement',
      routerLink: `cg-statement`,
      isDisabled: false,
      icon: <ReportsCGSDisabledIcon />,
      activeIcon: <CGStatIcon />,
      renderComponent: <CGStatement location={location} handleSideSectionDisabled={handleSideSectionDisabled} />,
      isHidden: false
    },
    // {
    //   title: 'Detailed Holding Report',
    //   routerLink: `DetailedHoldingReport`,
    //   isDisabled: true,
    //   icon: <ReportsDetailedHoldingDisabledIcon />
    // },
       {
      title: 'Portfolio XIRR Report',
      routerLink: `portfolio-xirr-report`,
      isDisabled: false,
      icon: <PortfolioXirrDisabledIcon />,
      activeIcon: <PortfolioXirrIcon/>,
      renderComponent: <PortfolioXirrReport handleSideSectionDisabled={handleSideSectionDisabled} />,
      isHidden: false
    },
    {
      title: 'Holding (T-1) Report',
      routerLink: `t-1-report`,
      isDisabled: false,
      icon: <T1ReportDisabledIcon />,
      activeIcon: <T1ReportIcon />,
      renderComponent: <T1Report handleSideSectionDisabled={handleSideSectionDisabled} />,
      isHidden: false
    },
  ];

  const links = [
    `${path}/client-statement`,
    `${path}/mf-transaction-wise-holding-report`,
    `${path}/holding-report`,
    `${path}/transaction-statement`,
    // `${path}/portfolio-summary`,
    `${path}/cg-statement`,
    // `${path}/DetailedHoldingReport`
    `${path}/portfolio-xirr-report`,
    `${path}/t-1-report`
  ];

  const Menulinks = links.includes(pathName) ? links : [];
  const MenuItems = links.includes(pathName) ? leftMenuItem : [];

  const currentPath = pathName.split('/');
  const menuPath = leftMenuItem?.filter(item => item.routerLink === currentPath[2])[0]?.title;


  // const [currentMenuItem, setCurrentMenuItem] = useState<string>(menuPath ? menuPath : 'Client Statement');
  const [currentMenuItem, setCurrentMenuItem] = useState<string>(menuPath ? menuPath : `${leftMenuItem.find(item => !item.isDisabled)?.title ?? leftMenuItem[0].title}`);

  const breadcrumbs = [

    <Link
      key="1"
      sx={{ cursor: 'pointer', textDecoration: 'none' }}
      onClick={() => history.push('/investors')}>
      Total Investors
    </Link>,
    <Typography key="2" color="text.primary">
      {investorName}
    </Typography>,
  ];

  return (
    // <CommonLayoutForInvestor>
    <CommonLayout>
      <>
        {/* <Box
          sx={{
            background: '#EEF9F4',
            borderRadius: '16px',
            px: 3,
            py: 1.5,
            mb: 2.5,
          }}>
          <Breadcrumbs
            separator={<NavigateNextIcon fontSize="small" />}
            aria-label="breadcrumb"
            sx={{
              '& .MuiTypography-root': {
                fontSize: 20,
                lineHeight: '23px',
                fontWeight: 500,
                color: '#BBB5B5',
                '&.MuiTypography-body1': { color: '#22242C' },
              },
              '& .MuiBreadcrumbs-separator': {
                '& .MuiSvgIcon-root': { color: 'rgba(0,0,0,0.6)' },
                '&:last-of-type': {
                  background: 'red',
                  '& .MuiSvgIcon-root': { color: '#22242C' },
                },
              },
            }}>
            {breadcrumbs}
          </Breadcrumbs>
        </Box> */}

        <Box
          sx={{
            width: ['100%', '100%', '100%'],
            // ml: [0, 1, 1],
            // pt: [0, 0, 2],
            pt: [0, 0, 0],
            pb: [0, 0, '60px'],
            boxSizing: 'border-box',
          }}>
          <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="flex-end"
            sx={{ mb: "25px", display: ['none', 'flex', 'flex'] }}>
            <Typography
              variant='h1'
              sx={{
                color: 'text.primary',
                lineHeight: '32.5px'
              }}>
              Reports
            </Typography>
          </Stack>
          <Hidden smUp={true}>
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="flex-end"
              sx={{ mb: "15px", display: { xs: 'flex', sm: 'none', md: 'none' } }}>
              <Typography
                variant='h1'
                sx={{
                  color: 'text.primary',
                  lineHeight: '32.5px'
                }}>
                Reports
              </Typography>
            </Stack>
            <Box
              sx={(theme: Theme) => (
                {
                  my: 3,
                  p: '20px 18px',
                  background: theme.palette.common.white,
                  borderRadius: '20px',
                  cursor: isSideSectionDisabled ? 'not-allowed' : 'pointer',
                  opacity: isSideSectionDisabled ? 0.5 : 1
                }
              )}
              onClick={() => {
                if (!isSideSectionDisabled) {
                  setOpenDrawer(true)
                }
              }}
            >
              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                {/* <FormControl fullWidth >
                    <InputLabel shrink id="investor-items"></InputLabel>
                    <Select
                      labelId="investor-items"
                      value={MenuItems[Menulinks?.indexOf(pathName)]?.routerLink}
                      onChange={(e) => {
                        history.push(`${e.target.value}`, {
                          investorId: investorId,
                          investorName: investorName,
                        });
                      }}
                      sx={(theme: Theme) => (
                        {
                          borderRadius: '20px',
                          background: theme.palette.common.white,
                          fontWeight: '500',
                          fontSize: '16px',
                          color: theme.palette.primary[500],
                          letterSpacing: '0.02px',
                          lineHeight: '18px'
                        }
                      )}
                      IconComponent={(props) => {
                        console.log("PROP", props);

                        // <ArrowDropDownIcon
                        //   {...props}
                        //   sx={{
                        //     paddingRight: '13px',
                        //     color: '#00D9DA !important',
                        //     cursor: 'pointer',
                        //   }}
                        //   fontSize="large"
                        // />
                        return (

                          <ExpandMoreIcon
                            {...props}
                            sx={(theme: Theme) => (
                              {
                                paddingRight: '13px',
                                color: theme.palette.text.primary,
                                cursor: 'pointer',
                              }
                            )}
                            fontSize="large"
                          />
                        )
                      }}
                    >
                      {leftMenuItem.map((itemlist, ind) => (
                        <MenuItem

                          sx={(theme: Theme) => (
                            {
                              color: theme.palette.text.secondary,
                              fontWeight: 500,
                              fontSize: '16px'
                            }
                          )}
                          divider
                          value={itemlist.routerLink}
                          key={ind}>
                          {itemlist.title}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl> */}
                <Box sx={{ display: 'flex', alignItems: 'center', columnGap: '10px' }}>
                  {leftMenuItem.find((item) => item.title === currentMenuItem)?.activeIcon}
                  <Typography
                    variant='subtitle_500'
                    sx={(theme: Theme) => ({
                      color: theme.palette.primary[500],
                      letterSpacing: '0.02px'
                    })}
                  >{currentMenuItem}
                  </Typography>
                </Box>
                <ExpandMoreIcon sx={{ color: theme.palette.text.primary }} />
              </Box>
            </Box>
          </Hidden>
          <Paper
            sx={{
              p: '25px',
              // backgroundColor: 'primary.light',
              // boxShadow: [0, 0, 24],
              // borderRadius: [0, 0, '10px'],
              // height: ['auto', 'auto', 'auto'],
              boxShadow: '0,0,0,rgba(0,0,0,0.05)',
              borderRadius: [0, 0, '25px'],
              height: ['auto', 'auto', 'auto'],
            }}>
            <Stack direction="row" sx={{ width: '100%' }}>
              <Hidden only="xs">
                <ReportLeftLayout>
                  {
                    leftMenuItem.map((itemlist, ind) => {
                      if (itemlist?.isHidden) return;
                      return (
                        <SectionLinkItem
                          to={{
                            pathname: `${path}/${itemlist.routerLink}`,
                            state: {
                              investorId: investorId,
                              investorName: investorName,
                            },
                          }}
                          title={itemlist.title}
                          icon={itemlist.icon}
                          disabled={isSideSectionDisabled || itemlist.isDisabled}
                          key={ind}
                        />
                      )
                    })
                  }
                  {/* <SectionLinkItem
                    to={{
                      pathname: `${path}/client-statement`,
                      state: {
                        investorId: investorId,
                        investorName: investorName,
                      },
                    }}
                    title={'Client Statement'}
                    icon={
                      // <CardMedia
                      //   component="img"
                      //   src="/images/client-statement.svg"
                      //   sx={{ width: 'unset', mx: 'auto' }}
                      // />
                      <ReportsMFTxnIconDisabled />
                    }
                    disabled={isSideSectionDisabled || leftMenuItem[0]?.isDisabled}
                  />
                  <SectionLinkItem
                    to={{
                      pathname: `${path}/transaction-statement`,
                      state: {
                        investorId: investorId,
                        investorName: investorName,
                      },
                    }}
                    title={'Transaction Statement'}
                    icon={
                      // <CardMedia
                      //   component="img"
                      //   src="/images/transaction-statement.svg"
                      //   sx={{ width: 'unset', mx: 'auto' }}
                      // />
                      <ReportsTxnHistoryDisabledIcon />
                    }
                    disabled={isSideSectionDisabled || leftMenuItem[1]?.isDisabled}
                  />
                  <SectionLinkItem
                    to={{
                      pathname: `${path}/mf-transaction-wise-holding-report`,

                    }}
                    title={'MF Transaction-wise Holding Report'}
                    icon={
                      <ReportsMFTxnIconDisabled />
                    }
                    disabled={isSideSectionDisabled || leftMenuItem[2]?.isDisabled}
                  />
                  <SectionLinkItem
                    to={{
                      pathname: `${path}/holding-report`,

                    }}
                    title={'Holding Report'}
                    icon={
                      <ReportsHoldingDisabledIcon />
                    }
                    disabled={isSideSectionDisabled || leftMenuItem[3]?.isDisabled}
                  /> */}
                  {/* <SectionLinkItem
                    to={{
                      pathname: `${path}/portfolio-summary`,
                      state: {
                        investorId: investorId,
                        investorName: investorName,
                      },
                    }}
                    title={'Portfolio Summary'}
                    icon={
                      // <CardMedia
                      //   component="img"
                      //   src="/images/portfolio-summary.svg"
                      //   sx={{ width: 'unset', mx: 'auto' }}
                      // />
                      <ReportsCGSDisabledIcon />
                    }
                    disabled={isSideSectionDisabled}
                  /> */}
                  {/* <SectionLinkItem
                    to={{
                      pathname: `${path}/cg-statement`,
                      state: {
                        investorId: investorId,
                        investorName: investorName,
                      },
                    }}
                    title={'CG Statement'}
                    icon={
                      // <CardMedia
                      //   component="img"
                      //   src="/images/cg-statement.svg"
                      //   sx={{ width: 'unset', mx: 'auto' }}
                      // />
                      <ReportsDetailedHoldingDisabledIcon />
                    }
                    disabled={isSideSectionDisabled}
                  /> */}
                  {/* <SectionLinkItem
                    to={{
                      pathname: `${path}/DetailedHoldingReport`,

                    }}
                    title={'Detailed Holding Report'}
                    icon={
                      <ReportsDetailedHoldingDisabledIcon />
                    }
                    disabled={isSideSectionDisabled}
                  /> */}
                </ReportLeftLayout>
              </Hidden>
              {/* <Divider
                  orientation="vertical"
                  sx={{
                    borderWidth: '1px',
                    borderColor: 'text.dividerLight',
                    mr: 1,
                    ml: 2,
                    display: ['none', 'none', 'flex'],
                  }}
                  flexItem
                /> */}
              <AnimatedBox
                sx={{
                  minWidth: "200px",
                  flex: 2
                }}
                className={transitionClassName}
              >
                <Box sx=
                  {{
                    border: `1px solid ${theme.palette.text.secondary}26`,
                    padding: '35px',
                    borderRadius: '15px',
                  }}
                >
                  <Router history={history}>
                    <Switch>
                      <Redirect
                        exact
                        from={path}
                        to={{
                          // pathname: `${path}/client-statement`,
                          pathname: `${path}/${leftMenuItem.find((item) => !item.isDisabled)?.routerLink}`,
                          state: { investorId, investorName },
                        }}
                      />
                      {
                        leftMenuItem.map((itemlist, ind) => (
                          <Route
                            key={ind}
                            path={`${path}/${itemlist.routerLink}`}
                            render={() => itemlist.renderComponent}
                          />
                        ))
                      }
                      {/* <Route
                        path={`${path}/client-statement`}
                        render={(props) => (

                          <ClientStatement
                            {...props}
                            // investorId={investorId}
                            // investorName={investorName}
                            location={location}
                            handleSideSectionDisabled={handleSideSectionDisabled}
                          />
                        )}
                      />
                      <Route
                        path={`${path}/mf-transaction-wise-holding-report`}
                        render={() => (
                          <MFTransactionWiseHoldingReport
                            handleSideSectionDisabled={handleSideSectionDisabled}
                          />
                        )}
                      />
                      <Route
                        path={`${path}/holding-report`}
                        render={() => (
                          <HoldingReport
                            handleSideSectionDisabled={handleSideSectionDisabled}
                          />
                        )}
                      />
                      <Route
                        path={`${path}/transaction-statement`}
                        render={(props) => (
                          <TransactionStatement
                            {...props}
                            // investorId={investorId}
                            // investorName={investorName}
                            location={location}
                            handleSideSectionDisabled={handleSideSectionDisabled}
                          />
                        )}
                      /> */}
                      {/* <Route
                        path={`${path}/portfolio-summary`}
                        render={(props) => (
                          <PortfolioSummary
                            {...props}
                            // investorId={investorId}
                            // investorName={investorName}
                            location={location}
                            handleSideSectionDisabled={handleSideSectionDisabled}
                          />
                        )}
                      /> */}
                      {/* <Route
                        path={`${path}/cg-statement`}
                        render={(props) => (
                          <CGStatement
                            {...props}
                            // investorId={investorId}
                            // investorName={investorName}
                            location={location}
                            handleSideSectionDisabled={handleSideSectionDisabled}
                          />
                        )}
                      /> */}
                      {/* <Route
                        path={`${path}/DetailedHoldingReport`}
                        render={() => (
                          <DetailedHoldingReport
                            handleSideSectionDisabled={handleSideSectionDisabled}
                          />
                        )}
                      /> */}
                    </Switch>
                  </Router>
                </Box>
              </AnimatedBox>
            </Stack>
          </Paper>
        </Box>

        {/* Drawer */}
        <Drawer anchor='bottom' open={openDrawer} onClose={() => setOpenDrawer(false)}
          sx={{
            borderRadius: '25px 25px 0px 0px',
            ".MuiPaper-elevation": {
              borderRadius: '25px 25px 0px 0px',
              backgroundColor: theme.palette.background.paper
            }
          }}
        >
          {<DrawerList currentMenuItem={currentMenuItem} setCurrentMenuItem={setCurrentMenuItem} leftMenuItem={leftMenuItem} setOpenDrawer={setOpenDrawer} links={links} theme={theme} />}
        </Drawer>
      </>
      {/* </CommonLayoutForInvestor> */}
    </CommonLayout>
  );
}


const DrawerList = ({ currentMenuItem, setCurrentMenuItem, leftMenuItem, setOpenDrawer, links, theme }: { currentMenuItem: string, setCurrentMenuItem: React.Dispatch<React.SetStateAction<string>>, leftMenuItem: ReportsRoutesObj[], setOpenDrawer: React.Dispatch<React.SetStateAction<boolean>>, links: any, theme: Theme }) => {
  const { path } = useRouteMatch();
  const history = useHistory();

  const handleClick = (row: any,) => {
    setOpenDrawer(false)
    setCurrentMenuItem(row?.title)
    history.push(row?.routerLink)
  }

  return (
    <List sx={{ padding: '10px 20px' }}>
      {leftMenuItem?.map((row: ReportsRoutesObj, index: number) => (
        <ListItemButton
          key={index}
          onClick={() => handleClick(row)}
          sx={{ display: 'flex', alignItems: 'center', columnGap: '15px', color: currentMenuItem === row?.title ? theme.palette.primary[500] : theme.palette.text.primary }}
          disabled={row?.isDisabled}
        >
          {/* {index === 0 && <ReportsMFTxnIconDisabled />}
          {index === 1 && <ReportsTxnHistoryDisabledIcon />}
          {index === 2 && <ReportsCGSDisabledIcon />}
          {index === 3 && <ReportsDetailedHoldingDisabledIcon />}
          {index === 4 && <ReportsHoldingDisabledIcon />} */}
          {currentMenuItem === row?.title ? row?.activeIcon : row?.icon}
          <ListItemText>
            {row?.title}
          </ListItemText>
        </ListItemButton>

      ))}
    </List>
  )
}
